export const MODAL_TYPES = {
  HELP: 'Help',
  DELETE_SHEET: 'DeleteSheet',
  DELETE_SECTION: 'DeleteSection',
  EMPTY_SECTION: 'EmptySection',
  SELECT_THEME: 'SelectTheme',
  GANTT_CHART: 'GanttChart',
  BACKGROUND_SELECT_PAGE: 'BackgroundSelectPage',
  SELECT_THEME_DIGITAL: 'SelectThemeDigital',
  ADD_DIGITAL_FRAME: 'AddDigitalFrame',
  OVERRIDE_LAYOUT: 'OverrideLayout',
  DELETE_FRAME: 'DeleteFrame',
  SAVE_LAYOUT: 'SaveLayout',
  SELECT_PAGE_OF_LAYOUT: 'SelectPageOfLayout',
  SAVE_DIGITAL_LAYOUT: 'SaveDigitalLayout',
  SAVE_STYLE_SUCCESS: 'SaveStyleSuccess',
  SAVE_LAYOUT_SUCCESS: 'SaveLayoutSuccess',
  SAVE_STYLE: 'SaveStyle',
  TRANSITION_PREVIEW: 'transitionPreview',
  PORTRAIT_FLOW: 'portraitFlow',
  PLAYBACK: 'playback',
  GENERATE_PDF: 'generatePDF',
  MAP_LAYOUT: 'mapLayout',
  APPLY_LAYOUT: 'applyLayout',
  CONTENT_MAPPING_OVERVIEW: 'contentMappingOverview',
  CONTENT_MAPPING: 'contentMappingModal',
  GENERATE_BACKGROUND: 'generateBackground',
  GENERATE_CLIPART: 'generateClipart'
};
